import React from "react";
import { GiPlainSquare } from "react-icons/gi";
import { MdArrowOutward } from "react-icons/md";
import engineer from "../../Assets/Our_Engeers.webp";
import builder from "../../Assets/Builders.webp";
import Architects from "../../Assets/Architech.webp";
import construction from "../../Assets/Construction.webp";
import safty from "../../Assets/Security.svg";
import ethics from "../../Assets/engineer_10344008.png";
import quality from "../../Assets/toolbox-green2.png";
import environment from "../../Assets/bulb.png";
import bg from '../../Assets/service-bg.jpg'
import { useNavigate } from "react-router-dom";

// Services Data
const services = [
  {
    title: "Engineers",
    image: engineer,
    description:
      "Our post-construction services give you peace of mind.",
  },
  {
    title: "Builders",
    image: builder,
    description:
      "We ensure high-quality building solutions tailored to meet your unique needs.",
  },
  {
    title: "Construction",
    image: construction,
    description:
      "Expert construction services with a focus on durability and sustainability.",
  },
  {
    title: "Architects",
    image: Architects,
    description:
      "Innovative architectural designs that blend aesthetics with functionality.",
  },
];

// Core Values Data
const coreValues = [
  {
    title: "Health & Safety",
    description:
      "We put health and safety first, maintaining strict standards to protect our team, clients, and community throughout every stage of construction.",
    image: safty,
  },
  {
    title: "Professional Ethics",
    description:
      "We uphold the highest standards of honesty, integrity, and professionalism, delivering quality work through safe and responsible construction. Our commitment to ethical practices ensures trust and long-lasting client relationships.",
    image: ethics,
  },
  {
    title: "Experience & Quality",
    description:
      "We don't just build structures; we forge legacies. For over 15 years, we have specialized in complex, high-integrity projects, ensuring every structure is built not just to code, but to endure. Our commitment is simple: meticulous craftsmanship, the finest materials, and proven structural longevity.",
    image: quality,
  },
  {
    title: "Environmental Protection",
    description:
      "We deliver lasting structures built on decades of expertise, Unwavering dedication to sustainability, integrating eco-friendly innovation and minimizing environmental footprint in every structure we build.",
    image: environment,
  },
];
 
const Service = () => {
const navigate = useNavigate()

  return (
    <div className="bg-gray-100">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="pt-12">
          {/* Section Header */}
          <div className="flex space-x-2 justify-center sm:justify-start">
            <GiPlainSquare className="text-[#068b07] pt-2" size={16} />
            <p className="text-gray-500 font-medium pt-1 text-sm">
              What we offer
            </p>
          </div>

          {/* Title & Button */}
          <div className="flex flex-col md:flex-row gap-4 md:gap-0 w-full py-8">
            <div className="md:w-1/2 p-2">
              <h1 className="text-2xl md:text-3xl font-bold text-center md:text-left">
                We Provide Excellent Service To Our Customers
              </h1>
              <p className="text-gray-500 text-sm font-medium mt-2 text-center md:text-left">
                Graviton construction is dedicated to being a partner for all of
                your construction needs.
              </p>
            </div>
            <div className="md:w-1/2 p-2 flex justify-center md:justify-end">
              <button
                className="flex gap-2 bg-[#068b07] text-white font-medium px-4 py-3 md:h-14 hover:bg-[#057a06] transition-colors"
                onClick={() => navigate("/services")}
              >
                <span>View All Services</span>
                <MdArrowOutward
                  className="bg-[#121315] text-white p-1"
                  size={32}
                />
              </button>
            </div>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white flex flex-col justify-between hover:shadow-lg transition-shadow"
              >
                <div className="p-4">
                  <div className="border-b-2 border-black pb-2">
                    <h1 className="font-semibold text-left">{service.title}</h1>
                  </div>
                  <p className="text-sm mt-2 text-gray-600">
                    {service.description}
                  </p>
                  <button
                    className="flex items-center font-medium mt-4 text-black hover:text-[#068b07] transition-colors"
                    onClick={() => navigate("/services")}
                  >
                    View More <MdArrowOutward className="ml-1" />
                  </button>
                </div>
                <div className="mt-auto z-20">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-48   object-cover"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Core Values Section */}
      <div className="relative mt-8 md:-mt-20">
        {/* Background Image */}
        <img
          src={bg}
          alt="background"
          className="w-full h-[180vh] md:h-screen object-cover"
        />

        {/* Overlay Content */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="flex flex-col items-center space-y-6 md:space-y-10">
              {/* Graviton Title */}
              <div className="flex flex-wrap items-center justify-center space-x-2">
                <GiPlainSquare className="text-[#068b07] size-3 md:size-4" />
                <p className="text-gray-500 text-xs md:text-sm text-center">
                  GRAVITON SINCE 2010
                </p>
                <GiPlainSquare className="text-[#068b07] size-3 md:size-4" />
              </div>

              {/* Main Heading & Description */}
              <div className="text-center max-w-4xl px-4">
                <h1 className="text-xl md:text-4xl font-semibold text-black leading-tight md:leading-snug">
                  Building Your Visions. Creating Reality
                </h1>
                <p className="text-gray-800 text-xs md:text-sm mt-3 md:mt-4 leading-relaxed">
                  "We transform your vision into reality with unwavering
                  commitment, technical expertise, and superior craftsmanship.
                  Every project we undertake is built on precision, innovation,
                  and a dedication to delivering results that exceed
                  expectations. Your vision drives us, and we turn it into
                  structures that stand strong, reliable, and enduring."
                </p>
              </div>
              {/* Divider Line */}
              <span className="flex items-center w-full pt-4 justify-center mx-auto space-x-2">
                <GiPlainSquare className="text-[#068b07]" size={12} />
                <div className="w-4/6 h-[1px] bg-gray-300"></div>
                {/* Centered Line */}
                <GiPlainSquare className="text-[#068b07]" size={12} />
              </span>

              {/* Core Values Section */}

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8 w-full">
                {coreValues.map((value, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-center text-center"
                  >
                    <img
                      src={value.image}
                      alt={value.title}
                      className="h-14 w-14 md:h-16 md:w-16 object-contain mb-2 md:mb-4"
                    />
                    <h3 className="text-md md:text-lg text-black font-semibold">
                      {value.title}
                    </h3>
                    <p className="text-xs md:text-sm text-gray-600 mt-1">
                      {value.description}
                    </p>
                  </div>
                ))}
              </div>

              {/* CTA Button */}
              <div className="w-full flex justify-center">
                <button
                  className="flex items-center gap-2 bg-[#068b07] text-white font-medium px-6 py-3  hover:bg-[#057a06] transition duration-300"
                  onClick={() => navigate("/services")}
                >
                  <span>View All Services</span>
                  <MdArrowOutward className="bg-[#121315] text-white p-1  size-5 md:size-6" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
